import { useState } from "react";
import usePlacesAutocompleteService from "react-google-autocomplete/lib/usePlacesAutocompleteService";

interface Params {
  defaultValue?: string;
}

export default function useGoogleMapsAddress(params?: Params) {
  const [input, setInput] = useState(params?.defaultValue ?? "");
  const [showPredictions, setShowPredictions] = useState(false);

  const { placesService, placePredictions, isPlacePredictionsLoading, getPlacePredictions } =
    usePlacesAutocompleteService({
      apiKey: "AIzaSyBv3Vl9DjNyz7FL-fwrF4xhVnywG6phgF4",
      debounce: 300,
      language: "en",
    });

  const getDetails = (
    prediction: google.maps.places.AutocompletePrediction
  ): Promise<google.maps.places.PlaceResult | null> => {
    return new Promise((resolve, reject) => {
      placesService?.getDetails({ placeId: prediction.place_id }, (placeResult, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK ||
          status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS
        ) {
          resolve(placeResult);
        } else {
          reject(status);
        }
      });
    });
  };

  const handleChange = (query: string) => {
    setInput(query);
    setShowPredictions(query !== "");
    getPlacePredictions({ input, componentRestrictions: { country: "us" } });
  };

  const handleSelectPrediction = (prediction: google.maps.places.AutocompletePrediction) => {
    setInput(prediction.description);
  };

  return {
    input,
    placePredictions,
    isPlacePredictionsLoading,
    handleChange,
    getDetails,
    showPredictions,
    setShowPredictions,
    handleSelectPrediction,
    setInput,
  };
}
